function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open'),
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach(
      (button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary'),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button'),
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary'),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom',
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    if(this.header) {
      this.header.classList.remove('menu-open');
    }else{

    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        )}px`,
      );
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`,
    );
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.slidesPerPage = (this.slidesPerPage === 0) ? 1 : this.slidesPerPage;
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
    this.updateVisibleElements();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    setTimeout(this.updateVisibleElements.bind(this), 500);

  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
    //setTimeout(this.updateVisibleElements.bind(this), 500);

  }

  updateVisibleElements(){
    var self = this
    this.sliderItems.forEach((item) =>{
      if(item.closest("slider-component") !== null) {
        if (self.isElementFullyVisible(item)) {
          item.classList.remove('no-quick-shop');
        } else {
          item.classList.add('no-quick-shop');
        }
      }
    });
  }

  isElementFullyVisible(element) {
    var rect = element.getBoundingClientRect();
    var containerRect = element.closest("slider-component").getBoundingClientRect();

    return (
        rect.top >= containerRect.top &&
        rect.left >= containerRect.left &&
        rect.bottom <= containerRect.bottom &&
        rect.right <= containerRect.right
    );
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      );

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true')
            this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener(
        'click',
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches ||
      this.announcementBarArrowButtonWasClicked ||
      !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active',
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (
      this.querySelector('.announcement-bar-slider').contains(event.target)
    ) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class ProductInfo extends HTMLElement {
  constructor() {
    super();
    this.updateOrderGrooveStyling();
  }

  updateOrderGrooveStyling() {
    // Create a MutationObserver to watch for OrderGroove elements
    const observer = new MutationObserver((mutations, obs) => {
      const orderGrooveSelectFrequencys = document.querySelectorAll(
        'og-select-frequency',
      );

      if (
        document.querySelector('.product__info-container og-select-frequency')
      ) {
        orderGrooveSelectFrequencys.forEach((orderGrooveSelectFrequency) => {
          // Wait for shadowRoot to be available
          if (!orderGrooveSelectFrequency.shadowRoot) {
            return;
          }

          // Add Styles
          orderGrooveSelectFrequency.style =
            'padding: 8px 16px; height: 51px; display: flex; align-items: center; position: relative; border: 1px solid var(--color-grey-slate); margin-top: 12px;';

          // Grabing the og-select to style
          const orderGrooveSelect =
            orderGrooveSelectFrequency.shadowRoot.querySelector('og-select');

          // Wait for og-select's shadowRoot to be available
          if (!orderGrooveSelect || !orderGrooveSelect.shadowRoot) {
            return;
          }

          // Add styles
          orderGrooveSelect.style =
            'width: 100%; background-image: url(https://cdn.shopify.com/s/files/1/0271/7209/files/truck-icon.svg?v=1744042907); background-repeat: no-repeat; background-size: 35px; padding-left: 38px; background-position: 0 center;';

          // Grabing the select arrow to style
          const orderGrooveShadowSelectArrow =
            orderGrooveSelect.shadowRoot.querySelector('span');
          if (orderGrooveShadowSelectArrow) {
            orderGrooveShadowSelectArrow.textContent = '';
            orderGrooveShadowSelectArrow.style = `background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='6' viewBox='0 0 11 6' fill='none'%3E%3Cpath d='M0.546875 0.5L5.27415 4.5L10.0014 0.5' stroke='white'/%3E%3C/svg%3E"); background-repeat: no-repeat; width: 12px; height: 6px; position: absolute; transform: none; top: calc(50% - 2px);`;
          }
        });

        // Only disconnect if all elements have been properly styled
        const allElementsStyled = Array.from(orderGrooveSelectFrequencys).every(
          (frequency) => {
            const select = frequency.shadowRoot?.querySelector('og-select');
            return select?.shadowRoot?.querySelector('span');
          },
        );

        if (allElementsStyled) {
          obs.disconnect();
        }
      }

      // Coffee Product Template Ordergroove updates
      if (document.querySelector('[data-template="product.coffee"]')) { 
        const orderGrooveButtons = document.querySelectorAll('.og-subscription-content');
        orderGrooveButtons.forEach(button => {

          const radioShadowRootOptin = button.querySelector('og-optin-button')?.shadowRoot?.querySelector('button');
          if (radioShadowRootOptin) radioShadowRootOptin.style.backgroundColor = '#201E1D'

          const radioShadowRootOptout = button.querySelector('og-optout-button')?.shadowRoot?.querySelector('button');
          if (radioShadowRootOptout) radioShadowRootOptout.style.backgroundColor = '#201E1D'
        });
      }
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

customElements.define('product-info', ProductInfo);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productID = this.getAttribute("data-product-id");
    this.createCustomDropdown();
    this.updateOptionsPrices();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    // Initialize current variant and run updateMikMak on page load
    this.updateOptions();
    this.updateMasterId();
    if (this.currentVariant) {
      this.updateMikMak(this.currentVariant);
    }
  }

  getIconClass(text){
    if(text === undefined){
      return "no-icon";
    }
    var handleText = text.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-unavailable/gi, '');

    var iconClass = '';
    if(handleText.includes('-lb') || handleText.includes('-bag')) {
      iconClass = 'icon-bag';
    }else if(handleText.includes('-cups') || handleText.includes('-count')){
      iconClass = 'icon-cups';
    }else{
      iconClass = 'icon-' + handleText;
    }
    return iconClass;
  }

  removeAllIconClasses(element){
    const classesToRemove = ['icon-whole-bean', 'icon-bag', 'icon-ground'];

    classesToRemove.forEach(className => {
      element.classList.remove(className);
    });
  }

  createdDefaultSelectedOption(text){
    const selectedOption = document.createElement("div");
    selectedOption.classList.add("selected-option");

    const seTextSpan = document.createElement("span");
    seTextSpan.textContent = text;
    if(text.toLowerCase().includes('unavailable')){
      selectedOption.classList.add("unavailable");
    }
    const iconClass = this.getIconClass(text);
    seTextSpan.classList.add('text', 'body-12', '!twcss-text-[10px]', 'lg:!twcss-text-[12px]', iconClass);

    const sePriceSpan = document.createElement("span");
    sePriceSpan.classList.add("price");
    selectedOption.appendChild(seTextSpan);
    selectedOption.appendChild(sePriceSpan);
    return selectedOption;
  }

  createOption(option){
    const optionItem = document.createElement("li");
    optionItem.setAttribute("data-value", option.value);
    if(option.textContent.toLowerCase().includes('unavailable')){
      optionItem.classList.add('unavailable');
    }

    const textSpan = document.createElement("span");
    textSpan.textContent = option.textContent.replace(/- unavailable/gi, '');;
    const iconClass = this.getIconClass(option.textContent);
    textSpan.classList.add('body-12', '!twcss-text-[10px]', 'lg:!twcss-text-[12px]', iconClass);

    const priceSpan = document.createElement("span");
    priceSpan.classList.add("price");
    optionItem.appendChild(textSpan);
    optionItem.appendChild(priceSpan);

    return optionItem;
  }

  createOptionList(dropdownOptionName, selectOptions, selectedOption, variantDropdown){
    const optionsList = document.createElement("ul");
    optionsList.classList.add("options-list");
    optionsList.setAttribute("data-option-name", dropdownOptionName);

    selectOptions.forEach(option => {

      const optionItem = this.createOption(option);

      optionItem.addEventListener("click", (event) => {
        selectedOption.querySelector('.text').textContent = option.textContent.trim().replace(/unavailable|-/gi, '');
        this.removeAllIconClasses(selectedOption.querySelector('.text'));
        selectedOption.querySelector('.text').classList.add(this.getIconClass(option.textContent.trim()));
        variantDropdown.value = option.value;
        optionsList.style.display = "none";
        const changeEvent = new Event("change", {bubbles: true});
        variantDropdown.dispatchEvent(changeEvent);
      });

      optionsList.appendChild(optionItem);
    });

    return optionsList;
  }

  createCustomDropdown(){
    const variantDropdowns = this.querySelectorAll(".select__select");
    variantDropdowns.forEach(variantDropdown => {
      //Hide the original Dropdown
      variantDropdown.parentNode.classList.add('twcss-hidden');
      const customDropdownContainer = variantDropdown.closest(".product-form__input--dropdown").querySelector(".custom-dropdown-container");
      const selectOptions = variantDropdown.querySelectorAll("option");
      const dropdownOptionName = variantDropdown.dataset.optionName;

      const customDropdown = document.createElement("div");
      customDropdown.classList.add("custom-dropdown");
      customDropdown.setAttribute("data-dropdown-type", dropdownOptionName);

      const firstOptionText = variantDropdown.options[0].innerText.trim().toLowerCase();
      let selectedOptionValue = variantDropdown.value;
      if (firstOptionText.includes('unavailable') && variantDropdown.dataset.optionName !== 'size') {
        selectedOptionValue += ' - Unavailable';
      }
      const selectedOption = this.createdDefaultSelectedOption(selectedOptionValue);

      customDropdown.appendChild(selectedOption);

      const optionsList = this.createOptionList(dropdownOptionName, selectOptions, selectedOption, variantDropdown);

      if(selectOptions.length > 1){
        selectedOption.addEventListener('click', (event) =>{
          var target = event.target;
          target.parentNode.querySelector('.options-list').style.display = target.parentNode.querySelector('.options-list').style.display === "block" ? "none" : "block";
        });
      }else{
        customDropdown.classList.add('unique-value');
      }

      customDropdown.appendChild(optionsList);
      customDropdownContainer.appendChild(customDropdown);
    });
    setTimeout(function(){
      variantDropdowns.forEach(variantDropdown => {
        const changeEvent = new Event("change", {bubbles: true});
        variantDropdown.dispatchEvent(changeEvent);
      })
    }, 1500)
  }

  updateOptionsPrices(){

    const customDropdowns = this.querySelectorAll('.custom-dropdown');
    if(customDropdowns.length > 0) {
      const selectHelper = document.querySelector('select[name="variantsHelper"][data-product-id="'+this.productID+'"]');

      var variantName = '';
      const variantOptions = this.querySelectorAll('select.select__select');
      variantOptions.forEach((variantOption, index) => {
        variantName += variantOption.value.toLowerCase().replace("$","").replace(/[^a-z0-9]+/g, '-');
        if (index < variantOptions.length - 1) {
          variantName += '-';
        }
      });

      const defaultVariantPrice = selectHelper.querySelector('[data-variant-helper="' + variantName + '"]').getAttribute('data-variant-price');

      customDropdowns.forEach((customDropdown, index) => {
        //I only add Prices to the Size Dropdown
        if (customDropdown.querySelector('.options-list').dataset.optionName === 'size') {
          customDropdown.querySelector('.selected-option .price').innerHTML = defaultVariantPrice;
          var variantName = '';
          var variantOption = '';
          if (customDropdowns.length > 1) {
            var vIndex = 0
            if(index === 0){
              vIndex = 1
            }
            variantName = customDropdowns[vIndex].querySelector('.selected-option .text').textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace('-unavailable', '');
          }

          customDropdown.querySelectorAll('ul.options-list li').forEach((option) => {
            if(index === 1) {
              variantOption = variantName + "-" + option.dataset.value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
            }else{
              variantOption = option.dataset.value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-') + (variantName !== "" ? "-" + variantName : "");
            }
            var optionHelper = selectHelper.querySelector('[data-variant-helper="' + variantOption + '"]');
            //set the price
            if (!optionHelper) {
              return;
            }
            option.querySelector('.price').innerHTML = optionHelper.getAttribute('data-variant-price');

            var variantIdHelper = optionHelper.value;
           
            const subscriptionVariantHelper = document.querySelector(`.subscriptionVariantHelper[data-variant-id="${variantIdHelper}"]`);
            const subscriptionLabelHelper = document.getElementById("subscription-label-helper"); 
            
            if (subscriptionLabelHelper && subscriptionVariantHelper && subscriptionVariantHelper.value === 'true') {
              let subscriptionLabelHelperValue = subscriptionLabelHelper.value;

              option.classList.add("show_subscription_label");
              subscriptionLabelHelperValue = `${subscriptionLabelHelperValue} ${subscriptionVariantHelper.dataset.discount}%`
              option.setAttribute("data-subscription-label", subscriptionLabelHelperValue);
            }
          });
        }
      })
    }
  }

  toggleOrdergrooveDropdown(currentVariant) {
    const ordergrooveDropdown = document.querySelector('.delivery-custom-dropdown');
    const currentVariantOrdergrooveInput = document.querySelector(`.subscriptionVariantHelper[data-variant-id="${currentVariant.id}"]`);

    // Toggle custom Ordergroove dropdown when subscription is set to "true" for current variant
    if (currentVariantOrdergrooveInput){
      const showOrdergroove = currentVariantOrdergrooveInput.value;

      if (showOrdergroove == 'true') {
        ordergrooveDropdown.style.display = 'block';
      } else {
        ordergrooveDropdown.style.display = 'none';
      }
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      if(this.getAttribute('data-plp') != null){
        this.updateVariantInputPLP();
      }else{
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }

    this.updateMikMak(this.currentVariant);
    this.toggleOrdergrooveDropdown(this.currentVariant);
    this.repaintOrdergrooveOptions();

    // Check og-offer visibility for PLP and remove selling_plan input if not visible
    if(this.getAttribute('data-plp') != null){
      const productForm = document.querySelector(`#custom-quick-shop-${this.productID}`);
      checkOgOfferVisibility(productForm);
    }
  }

  // Force Safari to repaint the shadow DOM text to prevent text from disappearing on selection
  repaintOrdergrooveOptions() {
    // Clear existing timeout
    if (this.repaintTimeout) {
      clearTimeout(this.repaintTimeout);
    }
    
    // Execute after user stops clicking
    this.repaintTimeout = setTimeout(() => {
      const buttons = document.querySelectorAll("og-optin-button, og-optout-button");

      buttons.forEach(el => {
        el.style.display = "none";
        requestAnimationFrame(() => {
          el.style.display = "block";
        });
      });
    }, 150);
  }

  updateMikMak(variant) {
    const mikMakWidget = document.getElementById('mik_mak_widget');
    if (!mikMakWidget) return;

    // Hide MikMak until updates are made
    mikMakWidget.style.display = 'none';

    const shopifyBarcode = variant.barcode;
    let barcode;

    const variantBarcodeMappings = [
      {
        // Dark Roast Single-Serve Pods, 10 Count
        'shopify_barcode': '851552005018', 
        'mik_mak_barcode': '856413007132'
      },
      {
        // Dark Roast Single-Serve Pods, 20 Count
        'shopify_barcode': '00851552005414', 
        'mik_mak_barcode': '856413007132'
      },
      {
        // Dark Roast Single-Serve Pods, 50 Count
        'shopify_barcode': '851552005421', 
        'mik_mak_barcode': '856413007132'
      },
      {
        // Dark Roast Single-Serve Pods, 100 Count
        'shopify_barcode': 'LCDARK100K', 
        'mik_mak_barcode': '856413007132'
      },
      {
        // Espresso Roast Single-Serve Pods, 10 Count
        // Espresso Roast Single-Serve Pods, 20 Count
        'shopify_barcode': '810063342531',
        'mik_mak_barcode': '810063342616'
      },
      {
        // Espresso Roast Single-Serve Pods, 50 Count
        'shopify_barcode': '810063342692',
        'mik_mak_barcode': '810063342616'
      },
      {
        // Espresso Roast Single-Serve Pods, 100 Count
        'shopify_barcode': 'LCESPR100K',
        'mik_mak_barcode': '810063342616'
      },
      {
        // Medium Roast Single-Serve Pods, 10 Count
        'shopify_barcode': '856413007606',
        'mik_mak_barcode': '856413007613'
      },
      {
        // Medium Roast Single-Serve Pods, 10 Count
        // Medium Roast Single-Serve Pods, 20 Count
        'shopify_barcode': '856413007606',
        'mik_mak_barcode': '856413007613'
      },
      {
        // Medium Roast Single-Serve Pods, 50 Count
        'shopify_barcode': '810063340438',
        'mik_mak_barcode': '856413007613'
      },
      {
        // Dark Roast Coffee, Ground 1lb
        // Dark Roast Coffee, Ground 2lb
        // Dark Roast Coffee, Ground 3lb
        'shopify_barcode': '851552005025',
        'mik_mak_barcode': '810063343040'
      },
      {
        // Dark Roast Coffee, Ground 5lb
        'shopify_barcode': '851552005056',
        'mik_mak_barcode': '810063343040'
      },
      {
        // Dark Roast Coffee, Whole Bean 1lb
        // Dark Roast Coffee, Whole Bean 2lb
        // Dark Roast Coffee, Whole Bean 3lb
        'shopify_barcode': '851552005100',
        'mik_mak_barcode': '810063343057'
      },
      {
        // Dark Roast Coffee, Whole Bean 5lb
        'shopify_barcode': '851552005087',
        'mik_mak_barcode': '810063343057'
      },
      {
        // Medium Roast Coffee, Ground 1lb
        // Medium Roast Coffee, Ground 2lb
        // Medium Roast Coffee, Ground 3lb
        // Medium Roast Coffee, Ground 5lb
        'shopify_barcode': '856413007583',
        'mik_mak_barcode': '810063343064'
      },
      {
        // Espresso Roast Coffee, Ground 1 bag
        // Espresso Roast Coffee, Ground 2 bag
        // Espresso Roast Coffee, Ground 3 bag
        // Espresso Roast Coffee, Ground 6 bag
        'shopify_barcode': '810063342517',
        'mik_mak_barcode': '810063343088'
      },
      {
        // Espresso Roast Coffee, Whole Bean 1 bag
        // Espresso Roast Coffee, Whole Bean 2 bag
        // Espresso Roast Coffee, Whole Bean 3 bag
        // Espresso Roast Coffee, Whole Bean 6 bag
        'shopify_barcode': '810063342524',
        'mik_mak_barcode': '810063342524'
      },
      {
        // Vanilla Single-Serve Pods, 10 Count
        // Vanilla Single-Serve Pods, 20 Count
        // Vanilla Single-Serve Pods, 30 Count
        'shopify_barcode': '810063343002',
        'mik_mak_barcode': '810063343002'
      },
      {
        // Vanilla Coffee, Ground 1 bag
        // Vanilla Coffee, Ground 2 bag
        // Vanilla Coffee, Ground 5 bag
        'shopify_barcode': '810063343330',
        'mik_mak_barcode': '810063342999'
      },
      {
        // Chocolate Hazelnut Single-Serve Pods, 10 Count
        // Chocolate Hazelnut Single-Serve Pods, 20 Count
        // Chocolate Hazelnut Single-Serve Pods, 30 Count
        'shopify_barcode': '810063343255',
        'mik_mak_barcode': '810063343255'
      },
      {
        // Chocolate Hazelnut Coffee, Ground 1 bag
        // Chocolate Hazelnut Coffee, Ground 2 bag
        // Chocolate Hazelnut Coffee, Ground 5 bag
        'shopify_barcode': '810063343248',
        'mik_mak_barcode': '810063343231'
      },
      {
        // Dark Roast Instant Coffee, 8 Count
        'shopify_barcode': '856413007408',
        'mik_mak_barcode': '856413007408'
      },
      {
        // Dark Roast Instant Coffee, 32 Count
        'shopify_barcode': '810063340568',
        'mik_mak_barcode': '856413007408'
      },
      {
        // Dark Roast Instant Coffee, 64 Count
        'shopify_barcode': '810063340575',
        'mik_mak_barcode': '856413007408'
      },
      {
        // Light Roast Coffee, Ground 1lb
        // Light Roast Coffee, Ground 2lb
        // Light Roast Coffee, Ground 3lb
        // Light Roast Coffee, Ground 5lb 
        'shopify_barcode': '810063344429',
        'mik_mak_barcode': '810063344375'
      },
      {
        // Vanilla Latte, Ready To Drink, 11oz
        'shopify_barcode': '810063343736',
        'mik_mak_barcode': '810063343736'
      },
      {
        // Mocha Latte, Ready To Drink, 11oz
        'shopify_barcode': '810063344474',
        'mik_mak_barcode': '810063344474'
      },
      {
        // Original Latte, Ready To Drink, 11oz
        'shopify_barcode': '810063344467',
        'mik_mak_barcode': '810063344467'
      }
    ];

    variantBarcodeMappings.forEach((variantBarcodeMapping) => {
      if (variantBarcodeMapping['shopify_barcode'] === shopifyBarcode){
        barcode = variantBarcodeMapping['mik_mak_barcode'];
      }
    });

    // Update widget with mapped variant barcode
    mikMakWidget.setAttribute('data-mm-ids', barcode);

    // Only show MikMak widget if barcode exists
    setTimeout(() => {
      if (!barcode) {
        mikMakWidget.style.display = 'none';
      } else {
        mikMakWidget.style.display = 'block';
      }
    }, 750);
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );
    
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;

    if (this.currentVariant.id.toString() !== searchParams.get('variant')) {
      searchParams.set('variant', this.currentVariant.id);
      const newUrl = `${currentUrl.origin}${currentUrl.pathname}?${searchParams.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }
  }


  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantInputPLP() {
    const productForm = document.querySelector(
        `#custom-quick-shop-${this.productID}`
    );
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this.toggleQuickShopAddButton(this.currentVariant.available);
  }

  updateCustomDropdownAvailability(customDropdownContainer, listOfAvailableOptions) {
    const customOptions = customDropdownContainer.querySelectorAll('.options-list li');
    customOptions.forEach((option, index) => {
      option.innerHTML = '';
      const textSpan = document.createElement("span");
      textSpan.textContent = listOfAvailableOptions[index];
      textSpan.classList.add(this.getIconClass(listOfAvailableOptions[index]))
      const priceSpan = document.createElement("span");
      priceSpan.classList.add("price");

      option.appendChild(textSpan);
      option.appendChild(priceSpan);
      option.setAttribute('data-value', listOfAvailableOptions[index]);
    });
    this.updateOptionsPrices();
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      const customDropdownContainer = option.querySelector('.custom-dropdown-container');
      if (index === 0) {
        if (customDropdownContainer) {
          this.updateOptionsPrices();
        }
        return;
      }
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);

      // Update custom dropdown availability
/*
      if (customDropdownContainer) {
        this.updateCustomDropdownAvailability(customDropdownContainer, availableOptionInputsValue);
      }
 */
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            'visibility-hidden',
            skuSource.classList.contains('visibility-hidden'),
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'visibility-hidden',
            inventorySource.innerText === '',
          );
        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        const isDisabled = addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true;

        this.toggleAddButton(isDisabled, window.variantStrings.soldOut);

        const monitor = document.querySelector('order-groove-optin-monitor');
        if (monitor) {
          const optInButton = document.querySelector('og-optin-button');
          monitor.updateButtonStatus(optInButton);
        }

        const soldOutForm = document.querySelector('.out-of-stock-form');
        if (soldOutForm) {
          soldOutForm.style.display = isDisabled ? "block" : "none";
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleQuickShopAddButton(available){
    const quickShopBtn = this.parentNode.querySelector('button[type="submit"]');
    const quickShopBtnLabel = quickShopBtn.querySelector('span');
    if(available){
      quickShopBtn.disabled = false;
      quickShopBtnLabel.innerHTML = 'Add to cart';
    }else{
      quickShopBtn.disabled = true;
      quickShopBtnLabel.innerHTML = 'Sold out';
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class CustomDeliveryDropdown extends HTMLElement {
  constructor() {
    super();

    this.selectedOption = this.querySelector(".selected-option");
    this.dropdownList = this.querySelector(".dropdown-list");
    this.selectedOption.addEventListener('click', this.showHideOptions.bind(this));
    this.dropdownList.addEventListener('click', (event) => this.updateFrequency(event));
    
    // Click to set default subscription length on page load
    // 60 days for items tagged with "bagged", 30 days for other items
    if (this.closest('.custom-ordergroove-container').classList.contains('custom-ordergroove-container--bagged')) {
      this.dropdownList.querySelector('[data-frequency="2_3"]').click();
    } else {
      this.dropdownList.querySelector('[data-frequency="1_3"]').click();
    }
  }

  showHideOptions = () => {
    this.dropdownList.style.display = this.dropdownList.style.display === "block" ? "none" : "block";
  }

  updateFrequency = (event) => {
      const clickedOption = event.target;
      const selectedValue = clickedOption.getAttribute("data-frequency");
      const ordergrooveContainer = this.closest('.custom-ordergroove-container');
      const ordergrooveSelectedOption = ordergrooveContainer.querySelector(`og-select-frequency option[value='${selectedValue}']`);
      const selectedProduct = document.querySelector('og-offer').getAttribute('product');
      const ogOffer = document.querySelector('og-offer');
      const ordergrooveFrequency = ordergrooveSelectedOption.getAttribute('value');
      
      this.selectedOption.innerHTML = clickedOption.innerHTML;
      this.dropdownList.style.display = "none";
      
      ogOffer.setAttribute('frequency', ordergrooveFrequency);    
      ordergrooveSelectedOption.click();
 
      this.setAttribute("data-product", selectedProduct);
  }
}

customElements.define('custom-delivery-dropdown', CustomDeliveryDropdown);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class tickerHandler extends HTMLElement {
  constructor() {
    super();
    this.width = 0;
    this.ticker = this.querySelector('.press-ticker__container');
    Shopify.designMode ? setTimeout(this.resizeHandler.bind(this), 100) : this.resizeHandler();
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
  }
  resizeHandler(){
    if(this.width == window.innerWidth) return;
	this.width = window.innerWidth;
    this.ticker.classList.remove('press-ticker--animation');
    var boxes = this.querySelectorAll('.press-ticker--clone');
    if(boxes.length){
      boxes.forEach(e => e.remove());
    }
    var length = window.innerWidth / this.ticker.offsetWidth,
        clone = false;
    length = length==Infinity?5:length;
    for(var i=0; i < length; i++){
      clone = this.ticker.cloneNode(true);
      clone.classList.add('press-ticker--clone');
      clone.classList.add('press-ticker--animation');
      this.append(clone);
    }
    this.ticker.classList.add('press-ticker--animation');
  }
}
customElements.define('ticker-section', tickerHandler);

class QuickShopOpener extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.showHideQuickShopFeature);
    this.quickShopContainer = this.closest(".quick-shop-feature-container").querySelector(".custom-quick-shop-wrapper");
    this.quickShopCloseBtn = this.closest(".quick-shop-feature-container").querySelector(".quick-shop-close");
    this.addToCartButton = this.closest(".quick-shop-feature-container").querySelector('.product-form.custom-quick-shop button[type="submit"]');
    this.quickShopCloseBtn.addEventListener('click', this.closeQuickShopFeature.bind(this));
    this.addToCartButton?.addEventListener('click', this.closeQuickShopAfterAddToCart.bind(this));
    this.sliderParent = this.closest('slider-component');
    const self = this;
    if(this.sliderParent) {
      this.prevButton = this.sliderParent.querySelector('button[name="previous"]');
      this.nextButton = this.sliderParent.querySelector('button[name="next"]');
      if (window.matchMedia('(max-width: 990px)')) {
        //The quick shop closes if it's inside a slider and a navigation arrow is pressed.
        this.nextButton.addEventListener('click', this.closeQuickShopFeature.bind(this));
        this.prevButton.addEventListener('click', this.closeQuickShopFeature.bind(this));
      }
      const sliderContent = this.sliderParent.querySelector('ul');
      sliderContent.addEventListener('scroll', function() {
          setTimeout(() => self.closeQuickShopFeature(), 500)
      });
    }
  }

  closeQuickShopAfterAddToCart(){
    setTimeout(() => this.closeQuickShopFeature(), 2000);
  }

  closeQuickShopFeature(){
    this.classList.remove("open");
    this.quickShopContainer.classList.remove("open");
    this.quickShopContainer.classList.remove("opened");
  }

  showHideQuickShopFeature(){

    if(this.sliderParent && !this.sliderParent.classList.contains('buttons-init')){
      //set max height for buttons - This prevents the slider navigation buttons from moving when the quick shop is opened.
      const sliderH = this.sliderParent.offsetHeight;
      if(sliderH > 0 && this.prevButton && this.nextButton) {
        this.prevButton.style.maxHeight = sliderH + 'px';
        this.nextButton.style.maxHeight = sliderH + 'px';
        this.sliderParent.classList.add('buttons-init');
      }
    }
    this.classList.toggle("open");
    this.quickShopContainer.classList.toggle("open");
    if(this.classList.contains("open")){
      const cardWrapper = this.closest('.card-wrapper');
      if(cardWrapper.classList.contains('subscription-eligible')){
        this.forceQuickShopSelectSize();
        this.forceQuickShopSubscriptionSelection();
      }
      setTimeout(() => {
        this.quickShopContainer.classList.add("opened");
      }, 600);
    }else{
      this.quickShopContainer.classList.remove("opened")
    }

    // Update the og-offer select width
    if (this.closest('.card').querySelector('og-offer og-select-frequency')) this.closest('.card').querySelector('og-offer og-select-frequency').shadowRoot.querySelector('og-select').style.width = '100%';
  }

  forceQuickShopSelectSize() {
    const sizeOptions = this.quickShopContainer.querySelectorAll('.options-list[data-option-name="size"] li');
    const targetSizes = ['2 lbs', '2 bags', '16 count', '20 count', '24 Pack'];

    sizeOptions.forEach(option => {
      if (targetSizes.includes(option.dataset.value)) option.click();
    });
  }

  forceQuickShopSubscriptionSelection() {
    const isSubscriptionSelected = this.quickShopContainer.querySelector('.og-optout-buttons [subscribed]');
    if (!isSubscriptionSelected) {
      const ogWhenElement = this.quickShopContainer.querySelector('og-optin-toggle og-when[test="subscriptionEligible"] button');
      if (ogWhenElement) {
        console.log(ogWhenElement)
        ogWhenElement.click();
      }
    }
  }
}

customElements.define('quick-shop-opener', QuickShopOpener);


class QuantiyChangeModal extends HTMLElement {
  constructor() {
    super();
    this.quantitySelect = this.previousElementSibling;
    this.quantitySelect && this.quantitySelect.addEventListener('change', this.openModal.bind(this));
    this.futureAmount = this.querySelector('.quantity-change-modal__future-amount');
  }

  openModal(event) {
    event.preventDefault();
    event.stopPropagation();

    // Set the future amount to the quantity selected
    this.futureAmount.textContent = this.quantitySelect.value;

    // Open the modal
    this.classList.add('modal--open');

    const confirmButton = this.querySelector('.quantity-change-modal__confirm');
    confirmButton.addEventListener('click', this.closeModal.bind(this));

    const closeButton = this.querySelectorAll('.quantity-change-modal__close');
    closeButton.forEach(button => {
      button.addEventListener('click', () => {
        // Reset the quantity to the initial quantity
        this.quantitySelect.querySelector('option[selected]').selected = true;
        this.quantitySelect.dispatchEvent(new Event('change'));

        this.closeModal();
      });
    });
  }

  closeModal() {
    this.classList.remove('modal--open');
  }
}

customElements.define('quantity-change-modal', QuantiyChangeModal);

class OrderGrooveOptinMonitor extends HTMLElement {
  constructor() {
    super();
    this.observers = new Map();
    this.init();
  }

  init() {
    // Initial check for existing buttons
    this.checkForOptinButtons();
    
    // Watch for new buttons being added to the DOM
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is an optin button
            if (node.tagName === 'OG-OPTIN-BUTTON') {
              this.monitorButton(node);
            }
            // Check if the added node contains optin buttons
            const optinButtons = node.querySelectorAll?.('og-optin-button');
            if (optinButtons) {
              optinButtons.forEach(button => this.monitorButton(button));
            }
          }
        });
      });
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  checkForOptinButtons() {
    const optinButtons = document.querySelectorAll('og-optin-button');
    optinButtons.forEach(button => this.monitorButton(button));

    const optoutButtons = document.querySelectorAll('og-optout-button');
    optoutButtons.forEach(button => this.monitorButton(button));
  }

  monitorButton(button) {
    // Skip if already monitoring this button
    if (this.observers.has(button)) return;

    // Initial check
    this.updateButtonStatus(button);

    // Create observer for this specific button
    const observer = new MutationObserver(() => {
      this.updateButtonStatus(button);
    });

    // Start observing the button's shadow root
    if (button.shadowRoot) {
      observer.observe(button.shadowRoot, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });
    } else {
      // If shadow root isn't available yet, wait for it
      const checkShadowRoot = () => {
        if (button.shadowRoot) {
          observer.observe(button.shadowRoot, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class']
          });
        } else {
          setTimeout(checkShadowRoot, 100);
        }
      };
      checkShadowRoot();
    }

    // Store the observer for cleanup
    this.observers.set(button, observer);
  }

  updateButtonStatus(button) {
    const shadow = button.shadowRoot;
    if (!shadow) return;

    const radio = shadow.querySelector('.radio');
    if (!radio) return;

    const isActive = radio.classList.contains('active');
    
    if (isActive) {
      button.closest('.og-subscription-content') && button.closest('.og-subscription-content').classList.add('has-active-radio');
      // Trigger custom event for other components to listen to
      button.dispatchEvent(new CustomEvent('optinButtonActivated', {
        detail: { button: button },
        bubbles: true
      }));
    } else {
      button.closest('.og-subscription-content') && button.closest('.og-subscription-content').classList.remove('has-active-radio');
      // Trigger custom event for other components to listen to
      button.dispatchEvent(new CustomEvent('optinButtonDeactivated', {
        detail: { button: button },
        bubbles: true
      }));
    }
    
    updateAddToCartText(button);
  }

  disconnectedCallback() {
    // Clean up all observers
    this.observers.forEach((observer) => {
      observer.disconnect();
    });
    this.observers.clear();
    
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('order-groove-optin-monitor', OrderGrooveOptinMonitor);

// Initialize the monitor when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Create and append the monitor element
  const monitor = document.createElement('order-groove-optin-monitor');
  document.body.appendChild(monitor);
});

// Also initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const monitor = document.createElement('order-groove-optin-monitor');
    document.body.appendChild(monitor);
  });
} else {
  const monitor = document.createElement('order-groove-optin-monitor');
  document.body.appendChild(monitor);
}

// Helper function to listen for optin button changes
function onOptinButtonChange(callback) {
  document.addEventListener('optinButtonActivated', (event) => {
    callback(event.detail.button, true);
  });
  
  document.addEventListener('optinButtonDeactivated', (event) => {
    callback(event.detail.button, false);
  });
}

// Helper function to get price from og-price shadow root
function getPriceFromOgPrice(ogPriceElement) {
  if (!ogPriceElement) return null;
  
  // Check if shadow root exists
  if (ogPriceElement.shadowRoot) {
    // Look for price element in shadow root
    const priceElement = ogPriceElement.shadowRoot;
    if (priceElement) {
      // Try to get price from text content
      const priceText = priceElement.textContent;
      const price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      if (price > 0) {
        return price;
      }
    }
  }
}

// Function to check for active Size radio buttons and calculate price per pound
function checkActiveSizeRadioAndPrice() {
  // Find all Size radio buttons
  const sizeRadios = document.querySelectorAll('input[type="radio"][name="Size"]');
  
  sizeRadios.forEach(radio => {
    if (radio.checked) {
      // Check if radio has data-ounces-per-unit attribute
      const ouncesPerUnit = radio.getAttribute('data-ounces-per-unit');

       if (ouncesPerUnit) {
        // If data-ounces-per-unit exists, set pricePerUnit to 'oz'
        pricePerUnit = 'oz';
      } else {
        // Use existing pricePerUnit logic
        if (radio.value.toLowerCase().includes('lbs')) {
          pricePerUnit = 'lb.';
        } else if (radio.value.toLowerCase().includes('bag')) {
          pricePerUnit = 'bag';
        } else if (radio.value.toLowerCase().includes('count')) {
          pricePerUnit = 'pod';
        }
      }
      // Extract pounds from the radio value (e.g., "3 lbs" -> 3)
      const poundsMatch = radio.value.match(/(\d+)\s*lbs?/i) || radio.value.match(/(\d+)\s*bags?/i) || radio.value.match(/(\d+)\s*count?/i);
      
      // Calculate unitCount based on pricePerUnit
      let unitCount = 0;
      if (pricePerUnit === 'oz' && poundsMatch && ouncesPerUnit) {
        // If pricePerUnit is 'oz', multiply pounds by ounces per unit
        unitCount = parseInt(poundsMatch[1]) * parseFloat(ouncesPerUnit);
      } else if (poundsMatch) {
        // Otherwise, use the existing logic (same as pounds)
        unitCount = parseInt(poundsMatch[1]);
      }
      
      if (unitCount > 0) {
        // Find all price wrappers and handle each one separately
        const priceWrappers = document.querySelectorAll('.price-wrapper');
        if (priceWrappers.length > 0) {
          // Remove all existing price per pound elements
          const existingPricePerPoundElements = document.querySelectorAll('.price-per-pound');
          existingPricePerPoundElements.forEach(element => element.remove());
          
          // Process each price wrapper
          priceWrappers.forEach(priceWrapper => {
            // Check if this price wrapper contains the pay-as-you-go price
            const payAsYouGoPrice = priceWrapper.querySelector('og-price[pay-as-you-go]');
            
            if (payAsYouGoPrice) {
              // This price wrapper contains pay-as-you-go, so show discounted price
              const regularPrice = document.querySelector('og-price[regular]');
              
              if (regularPrice) {
                const payAsYouGoValue = getPriceFromOgPrice(payAsYouGoPrice);
                const regularValue = getPriceFromOgPrice(regularPrice);
                
                if (payAsYouGoValue > 0 && regularValue > 0) {
                  // Calculate discount percentage
                  const discountPercentage = ((regularValue - payAsYouGoValue) / regularValue * 100).toFixed(0);
                  
                  // Calculate price per pound for pay-as-you-go (cheaper option)
                  const pricePerPound = (payAsYouGoValue / unitCount).toFixed(2);
                  
                  // Create and insert price per pound element with discount info
                  const pricePerPoundElement = document.createElement('div');
                  pricePerPoundElement.className = 'price-per-pound';
                  pricePerPoundElement.innerHTML = `$${pricePerPound}/${pricePerUnit} <strong>${discountPercentage}% Off</strong>`;
                  
                  // Insert inside the price wrapper
                  priceWrapper.appendChild(pricePerPoundElement);
                }
              }
            } else {
              // This price wrapper doesn't contain pay-as-you-go, so show regular price per pound
              const ogPriceElement = priceWrapper.querySelector('og-price');
              
              if (ogPriceElement) {
                const price = getPriceFromOgPrice(ogPriceElement);
                
                if (price > 0) {
                  const pricePerPound = (price / unitCount).toFixed(2);
                  
                  // Create and insert price per pound element
                  const pricePerPoundElement = document.createElement('div');
                  pricePerPoundElement.className = 'price-per-pound';
                  pricePerPoundElement.textContent = `$${pricePerPound}/${pricePerUnit}`;
                  
                  // Insert inside the price wrapper
                  priceWrapper.appendChild(pricePerPoundElement);
                }
              }
            }
          });
        }
      }
    }
  });
}

function forceSelectSize() {
  const sizeRadios = document.querySelectorAll('input[type="radio"][name="Size"]');
  const targetSizes = ['2 lbs', '2 bags', '16 count', '20 count', '24 Pack'];
  sizeRadios.forEach(radio => {
    if (targetSizes.includes(radio.value)) radio.click();
  });
}

function forceSubscriptionSelection() {
  const ogWhenElement = document.querySelector('og-when[test="subscriptionEligible"]');
  if (ogWhenElement) {
    // Find the button inside the og-optin-button-item div
    const optinButtonItem = document.querySelector('.og-optin-button-item');
    if (optinButtonItem) {
      const button = optinButtonItem.querySelector('og-optin-button');
      if (button) {
        button.click();
        updateAddToCartText(button);
      }
    }
  }
}

function updateAddToCartText(button) {
  const addToCartButton = document.querySelector('.product-form__submit');
  if (button.closest('.og-optin-button-item') && button.closest('.has-active-radio') && button.closest('og-offer').getBoundingClientRect().height > 50) {
    // Update add to cart text 
    addToCartButton.querySelector('span').textContent = 'Start a new Subscription';
  } else if (button.closest('.og-optout-buttons') && button.closest('.has-active-radio')) {
    // Update add to cart text 
    addToCartButton.querySelector('span').textContent = 'Add to Cart';
  }
}

function checkOgOfferVisibility(form) {
  // Use setTimeout to allow DOM to update after variant change
  setTimeout(() => {
    const isQuickShop = form ? true : false;
    const productForm = isQuickShop ? form : document.querySelector('product-form');
    const quickShopWrapper = isQuickShop ? form.closest('.custom-quick-shop-wrapper') : null;

    if (!productForm) return;
    if (isQuickShop && !quickShopWrapper) return;

    const ogOffer = isQuickShop ? quickShopWrapper.querySelector('og-offer') : document.querySelector('og-offer');
    if (!ogOffer) return;

    // Get styles for og-offer element
    const computedStyle = window.getComputedStyle(ogOffer);

    // Check if og-offer has visible content by checking its height
    // The element might have padding even when empty, so check if height is minimal
    const rect = ogOffer.getBoundingClientRect();
    const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
    const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
    const minVisibleHeight = paddingTop + paddingBottom;
    const isVisible = rect.height > minVisibleHeight;

    if (!isVisible) {
      const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput) {
        sellingPlanInput.remove();
      }
    }
  }, 300); // Delay to allow og-offer to update after variant change
}

// Monitor for Size radio button changes
function monitorSizeRadioChanges() {
  // Check initially
  checkActiveSizeRadioAndPrice();
  
  // Monitor for changes
  document.addEventListener('change', (event) => {
    if (event.target.type === 'radio' && event.target.name === 'Size') {
      setTimeout(() => {
        checkOgOfferVisibility();
        checkActiveSizeRadioAndPrice();
      }, 100);
    }
  });
}

// Initialize monitoring
document.addEventListener('DOMContentLoaded', () => {
  const productWrapper = document.querySelector('.product');
  monitorSizeRadioChanges();
  if(productWrapper.classList.contains('subscription-eligible')){
    forceSelectSize();
  }
});

// Also initialize immediately if DOM is already loaded
if (document.readyState !== 'loading') {
  monitorSizeRadioChanges();
}

// Add click listeners to container and button pairs
function addContainerClickListeners() {
  const containerButtonPairs = [
    { container: '.og-optout-buttons', button: 'og-optout-button' },
    { container: '.og-optin-buttons', button: 'og-optin-button' },
  ];

  containerButtonPairs.forEach(({ container, button }) => {
    const containerEl = document.querySelector(container);
    const buttonEl = document.querySelector(button);

    if (containerEl && buttonEl) {
      containerEl.addEventListener('click', () => buttonEl.click());
    }
  });
}

// Run on page load with a slight delay to ensure all elements are loaded
function runOnPageLoad() {
  const productWrapper = document.querySelector('.product');
  setTimeout(() => {
    checkActiveSizeRadioAndPrice();
    if(productWrapper.classList.contains('subscription-eligible')){
      checkOgOfferVisibility();
      forceSelectSize();
      forceSubscriptionSelection();
    }
    addContainerClickListeners();
  }, 1000); // 1 second delay to ensure OrderGroove elements are loaded
}

// Run on page load
document.addEventListener('DOMContentLoaded', runOnPageLoad);
if (document.readyState !== 'loading') {
  runOnPageLoad();
}

// Klaviyo Form Submit
window.addEventListener("klaviyoForms", function(e) {
  if (e.detail.type == 'submit') {
    // Image pixel
    var img = new Image();
    img.src = "https://bttrack.com/Pixel/Conversion/16681/signup?type=img";
    img.width = 1;
    img.height = 1;
    img.style.display = "none";
    document.body.appendChild(img);

    // Script pixel
    var script = document.createElement("script");
    script.src = "https://tag.simpli.fi/sifitag/52f3dd53-6644-4704-bb10-33449f0f5071";
    script.async = true;
    document.head.appendChild(script);
  }
});